<template>
  <v-dialog
      v-model="infoAlertState"
      persistent
      width="800"
  >
    <v-card :class="alertType">

      <v-alert :type="alertType" :class="alertTypeText" :icon="false" >
        <span :style="{fontSize: getAlertFontSize}">{{ text }}</span>
      </v-alert>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :class="alertTypeText" text @click="infoAlertState = false">Entendido</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'info-alert',
  props: {
    value: {type: Boolean},
    text: {type: String, default: "Aviso informativo"},
    alertType: {type: String, default: ''},
    alertFontSize: {type: String, default: 'S'}
  },
  data() {
    return {
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth
    }
  },
  computed: {
    infoAlertState: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    getAlertFontSize() {
      switch (this.alertFontSize) {
        case 'XS':
          return '0.75rem'
        case 'S':
          return '1rem'
        case 'M':
          return '1.25rem'
        case 'L':
          return '1.5rem'
        case 'XL':
          return '1.75rem'
        case 'XXL':
          return '2rem'
        default:
          return '1rem'
      }
    },
    alertTypeText() {
      switch (this.alertType) {
        case 'white':
          return 'black--text'
        case 'black':
          return 'white--text'
        case 'error':
          return 'white--text'
        case 'warning':
          return 'white--text'
        case'success':
          return 'white--text'
        case'info':
          return 'white--text'
        default:
          return 'black--text'
      }

    }
  }
}
</script>

<style>

</style>
